<div *ngIf="error">
    <app-error-text message="Chargement des éléments impossible"></app-error-text>
</div>
<app-select-filter *ngIf="!error"
        [elements]="elements"
        [filterElementProcessor]="filterElementProcessor"
        [loading]="loading"
        [noValueLabel]="noValueLabel"
        [parentFormControlName]="parentFormControlName"
        [parentFormGroup]="parentFormGroup"
        (_onSingleSelectionChange)="onSelectionChanged($event)"
        [errorsMessages]="errorsMessages"
        [deletable]="clearable"
>
    <ng-template let-element='element' template-content>
        <ng-container [ngTemplateOutletContext]="{element:element}" [ngTemplateOutlet]="template"></ng-container>
    </ng-template>
</app-select-filter>
